export default "__VITE_ASSET__DAm79Mc0__"